import { LayoutBase } from './LayoutBase';

export default class extends LayoutBase {
  private getIndexPicEl(index: number) {
    const { imgEl, src } = this.getFrameImgEls()[index] ?? {};
    return { imgEl, src };
  }

  private getFrameImgEls() {
    const { children } =
      this.runtime.getDataItem<IImageArray>((this.dataItem as ISprite).ref) ??
      {};
    return children ?? [];
  }

  getSize(): { width: number; height: number } {
    const { imgEl } = this.getIndexPicEl(0) ?? {};
    return {
      width: imgEl?.width ?? 0,
      height: imgEl?.height ?? 0
    };
  }

  private drawSprite() {
    // const { x, y, ctx } = this;
    // 获取序列帧数据
    // 总数
    const total = this.getFrameImgEls().length ?? 0;
    this.setRuntimeData({ frameTotal: total });
    // 本次序列帧index
    // 是否正在播放此序列帧
    const ani = this.runtime.frameAnis.find(
      (item) => item.shapeId == this._layoutId
    );
    // 如果存在动画，取动画的index，否则取默认值
    const defaultIndex = (this.dataItem as ISprite)._defaultIndex ?? 0;
    const { frameIndex: _frameIndex = defaultIndex } = ani ?? {};
    const frameIndex = Math.min(_frameIndex, total - 1);

    // 渲染图片
    const { imgEl, src } = this.getIndexPicEl(frameIndex) ?? {};
    if (!imgEl) return;

    const { width, height } = imgEl;
    // 离屏画布
    const { canvas: _canvas } = this.getOffscreen({
      width,
      height,
      init: (_, ctx) => {
        this.drawRecolorImage(ctx, imgEl, {
          x: 0,
          y: 0
        });
      },
      dirtyParmas: { src: src ?? '' }
    });
    this.drawAniFrame(_canvas);

    this.setRuntimeData({
      width,
      height,
      frameIndex
    });
    // 播放完成后处理下一步
    ani?.after(total);
    // ani?.updateRepeatedCount(frameIndex >= total - 1);
  }

  private drawVideo(vidoeFilename: string) {
    const { x, y, ctx } = this;

    const videoEl = this.runtime.videos[vidoeFilename ?? ''];
    if (!videoEl) return;
    videoEl.muted = true;
    videoEl.autoplay = true;
    ctx.drawImage(videoEl, x, y);
    this.setRuntimeData({
      width: videoEl.videoWidth,
      height: videoEl.videoHeight
    });
    // 播放完成后，设置video状态
    const ani = this.runtime.frameAnis.find(
      (item) => item.shapeId == this._layoutId
    );
    ani?.after();
  }

  private drawImage(image: IImage) {
    const { imgEl } = image;
    if (!imgEl) return;
    const { width, height } = imgEl;
    // 离屏画布
    const { canvas: _canvas } = this.getOffscreen({
      width,
      height,
      init: (canvas, ctx) => {
        this.drawRecolorImage(ctx, imgEl, {
          x: 0,
          y: 0
        });
      },
      dirtyParmas: {
        src: image.src ?? ''
      }
    });

    this.drawAniFrame(_canvas);
    this.setRuntimeData({
      width: imgEl.width,
      height: imgEl.height
    });
  }

  draw(): void {
    const { ref, refExt } = this.dataItem as ISprite;
    const file = this.runtime.getDataItem<IFile | IImageArray | IImage>(
      refExt ?? ref
    );

    if (file?.tagType == 'ImageArray') {
      this.drawSprite();
    } else if (file?.tagType == 'File') {
      this.drawVideo((file as IFile).fileName);
    } else if (file?.tagType == 'Image') {
      this.drawImage(file as IImage);
    }
  }
}
